import React from 'react';
import { Row, Col } from 'react-bootstrap';
import MediaQuery from 'react-responsive';

import CandidatePhoto from '../../CandidatePhoto/CandidatePhoto';
import cvLink from '../../../assets/images/print.png';
import './CandidateSummary.css';
import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';
/**
* @desc Highlight   experience in candidate profile section
* @param props
* @return DOMElement
*/
const HighlightExperience = (props) => {
  return (
    <div className="highlight-experience">
      <MediaQuery query="(max-device-width: 767px)">
        <span className="job-title">{(props.JobTitle)}</span> <br />
        <span className="company">{props.CurrentEmployer}</span>
      </MediaQuery>
      <MediaQuery query="(min-device-width: 768px)">
        {/* <span className="candidate-name">{props.JobTitle}</span>  */}
        <span className="job-title">{props.JobTitle}</span> 
        <span className="divider">|</span> 
        <span className="company">{props.CurrentEmployer}</span>
      </MediaQuery>
    </div>
  );
}
/**
* @desc Highlight Previous experience in candidate profile section
* @param props
* @return DOMElement
*/
const HighlightPreviousExperience = (props) => {
  return (    
    <div className="highlight-experience">
      <span className="job-title">
        {props.position}
      </span> 
      <span className="divider">|</span> 
      <span className="company">
        {props.company}
      </span>
    </div>
  );
}
/**
* @desc  PrintButton in candidate profile section
* @param props
* @return PrintButton
*/
function PrintButton(props) {
  const print = props.print
  if (print) {
    return <div className="cv-link"><img src={cvLink} alt="CV Link" /></div>  
  }
  return ''
}
/**
* @desc Brief summary of candidate in candidate profile section
* @param props
* @return DOMElement
*/
const CandidateSummary = (props) => {
  const candidate_id = props.candidate_id;
  let candidate = props.candidate;
  let experience = []; ConsoleLog('props printed', props)
  if(candidate.work_summary && candidate.work_summary !== null) {
    experience = candidate.work_summary.split('@@@').map((exp, index) => {
      return {
        'id' : exp.split('###')[0],
        'company' : exp.split('###')[1],
        'title' : exp.split('###')[2],
        'current_role' : exp.split('###')[6],
      };
    });
  }

  return (
    
    <div className="candidate-summary">
      <PrintButton print={props.print} />
      <div className="profile-picture">
        <CandidatePhoto 
          firstname={candidate.candidate_fname}
          lastname={candidate.candidate_lname} 
          candidatePhoto={candidate.s3SignedUrl} 
          initials={candidate.initials} 
        />
      </div>

      <div className="details">
        <h1>{(candidate.candidate_fname || candidate.candidate_lname )?candidate.candidate_fname + " " + candidate.candidate_lname:"- Not Specified -"}</h1>

        {experience.filter((currentExp) => currentExp.current_role === "1").length > 0 ?
          experience.filter((currentExp) => currentExp.current_role === "1").map((currentExp, index) => {
            if(index > 0) {
              return;
            }
            return (
              <HighlightExperience 
                JobTitle={currentExp.title} 
                CurrentEmployer={currentExp.company?currentExp.company:"- Not Specified -"} 
              />
            ); 
          
            }) : 
            ((candidate.current_job_title /*&& candidate.current_employer*/) ?
            <HighlightExperience 
              JobTitle={candidate.current_job_title} 
              CurrentEmployer={candidate.current_employer?candidate.current_employer:"- Not Specified -"} 
            /> 
            : 
            <div>
              <span className="not">Actively Seeking Employment</span>
            </div>
          )
        }
      </div>
      <hr className="hr-style" />
      <div>
        <h2>Previous Experience</h2>
        <MediaQuery query="(max-device-width: 767px)">   

          {/* {experience.filter((currentExp) => currentExp.current_role === "1").length > 1 ? experience.filter((currentExp) => currentExp.current_role === "1").map((currentExp, index) => {
            if(index === 0 || index > 2) {
              return;
            }
            return (
              <HighlightPreviousExperience  
                key={index} 
                position={currentExp.title} 
                company={currentExp.company} 
              />
            ); 
          
            }) : ''
          }
          {(experience.filter((currentExp) => currentExp.current_role === "1").length < 2 && experience.filter((prevExp) => prevExp.current_role === "0").length > 0) ? experience.filter((prevExp) => prevExp.current_role === "0").map((prevExp, index) => {
              const curExpLength = experience.filter((currentExp) => currentExp.current_role === "1").length;
              if((parseInt(index + curExpLength > 2) && (curExpLength > 1 )) || ((curExpLength === 0) && index > 1)) {
                return;
              }
              return (
                <HighlightPreviousExperience  
                  key={index} 
                  position={prevExp.title} 
                  company={prevExp.company} 
                />
              )
            }) : 'NA'               
          } */}

          {((experience.filter((exp) => (exp.current_role === "1" && exp.title !== "")).length > 1) || (experience.filter((exp) => (exp.current_role === "0" && exp.title !== "")).length > 0)) ?
          <Row className={"show-grid previous-experience-content" + ((props.isProfileEdit && !props.isPreview) ? " previous-experience-content-full-width" : "") } >                            
            <Col md={12}>
              { (experience.filter((prevExp) => (prevExp.current_role === "0"  && prevExp.title.trim() !== "")).length > 0) ? 
                experience.filter((prevExp) => (prevExp.current_role === "0" && prevExp.title !== "")).map((prevExp, index) => {
                  if( index > 1) {
                    return;
                  } 
                  return (
                    <HighlightPreviousExperience  
                    key={index} 
                    position={prevExp.title} 
                    company={prevExp.company?prevExp.company:"- Not Specified -"} 
                  />
                  )
                }) : '' 
              }
              {(props.isProfileEdit && !props.isPreview || props.isPrint) ? null :null}
            </Col>                                          
          </Row>
          : <span className="highlight-experience-nil">NA</span> 
          }

        </MediaQuery>
      </div>
      <hr className="hr-style"/>

      <Row className="meta show-grid">
        <Col xs={12} md={5}>
          {(candidate.notice_period) ? 
            <span className="notice">
              { (candidate.notice_period != "Immediately Available") ? 
                candidate.notice_period + " Notice Period" 
                : (candidate.notice_period == "Immediately Available")?"Immediately Available":""}
            </span>
          : <span className="notice">Notice Period : NA</span>
          }
        </Col>
        <Col xs={12} md={5}>
          {(candidate.job_type) ? 
            <span className="jobtype">
              {candidate.job_type}
            </span>: 
            <span className="jobtype">Job Type : NA</span>
          }
        </Col>
      </Row>
    </div>    
  );
}

export default CandidateSummary;



// WEBPACK FOOTER //
// ./src/components/Client/CandidateSummary/CandidateSummary.js